import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
// src/pages/e3/portfolios/columns.tsx

import { ExternalLink } from "@/components/ExternalLink";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { CheckIcon } from "@radix-ui/react-icons";
import { ColumnDef } from "@tanstack/react-table";

// import { getAuditColumns } from "@/features/Audit/getAuditColumns";

export type E3Portfolio = {
  id: number;
  client: string;
  vehicle: string | null;

  account_name: string;
  short_account_name: string | null;

  name: string;
  currency: string;
  reporting_currency: string;

  bank_name: string | null;
  account_type: string;

  investment_type: string | null;
  contract_name: string | null;

  // E3 only
  insurance_company: string | null;
  contract_owner: string | null;

  code: string;

  has_pdf_bank_page: boolean | null;
  display_performance_report: boolean | null;
  bank_connection: boolean | null;

  collateral: boolean | null;
  has_transactions?: boolean;

  vehicle_index: number | null;
};

const boolCell =
  () =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ({ getValue }: any) =>
    Boolean(getValue()) && (
      <div className="flex justify-center">
        <CheckIcon />
      </div>
    );

export const porfolios_columns: ColumnDef<E3Portfolio>[] = [
  { accessorKey: "id", header: "Id" },
  { accessorKey: "client", header: "Client" },
  {
    accessorKey: "vehicle",
    header: "Véhicule / Bénéficiaire du compte",
  },

  { accessorKey: "account_name", header: "Groupe de comptes" },
  { accessorKey: "name", header: "Compte" },

  // New
  { accessorKey: "short_account_name", header: "Nom court du compte" },

  { accessorKey: "currency", header: "Devise du portefeuille" },
  { accessorKey: "reporting_currency", header: "Devise de reporting" },
  { accessorKey: "bank_name", header: "Banque" },
  { accessorKey: "account_type", header: "Type de compte" },

  { accessorKey: "investment_type", header: "Type d'investissement" },
  { accessorKey: "contract_name", header: "Nom du contrat" },

  // E3 only
  { accessorKey: "insurance_company", header: "Compagnie d’assurance" },
  { accessorKey: "contract_owner", header: "Titulaire du contrat d’assurance" },

  { accessorKey: "code", header: "Code" },

  // Rename: PDF -> PDF du compte
  {
    accessorKey: "has_pdf_bank_page",
    header: () => (
      <div className="text-center">{i18n.t("portfolios.pdf_account_page")}</div>
    ),
    cell: boolCell(),
  },

  // New: PDF performance
  {
    accessorKey: "display_performance_report",
    header: () => (
      <div className="text-center">
        {i18n.t("portfolios.pdf_performance_page")}
      </div>
    ),
    cell: boolCell(),
  },

  // New: bank connection
  {
    accessorKey: "bank_connection",
    header: () => (
      <div className="text-center">{i18n.t("portfolios.bank_connection")}</div>
    ),
    cell: boolCell(),
  },

  {
    accessorKey: "collateral",
    header: "Compte-titres nanti",
    cell: boolCell(),
  },

  {
    accessorKey: "vehicle_index",
    header: () =>
      i18n.t("e3_portfolios.columns.vehicle_index", {
        ns: "tables",
        defaultValue: "Vehicle index (def)",
      }),
  },

  {
    id: "actions",
    cell: ({ row }) => {
      const hasTransactions = row.original.has_transactions;

      return (
        <div className="flex gap-3 justify-end">
          <ExternalLink
            href={toWorkspacePath("/admin/e3/e3_transactions")}
            queryParams={{ e3_portfolios_id_equal: row.getValue("id") }}
            className={`text-xs ${
              !hasTransactions ? "invisible pointer-events-none" : ""
            }`}
            underline="hover"
          >
            Transactions
          </ExternalLink>
          <Link
            href={`${window.location.pathname}/${row.getValue("id")}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];

// export const porfolios_audit_columns = getAuditColumns<E3Portfolio>(porfolios_columns)
